import axios from 'axios'
import {resolvePatronApiPath} from './ServerBasePathResolver'
import {getAccessToken} from './auth.service'
import {provisionTenantDirectly} from '@/tenants/org.service'

const pracsysUrl = window.location.protocol + '//' + window.location.hostname

export const patronUrl = window.location.protocol + '//start.' + window.location.hostname.split('.').slice(1).join('.')

export const signInUrl = patronUrl + '/signin?redirectUrl=' + encodeURIComponent(pracsysUrl)

export const signOutUrl = patronUrl + '/signout'

export const fetchPatronOverview = async (tenantId: string) => {
    const path = `/patrons/${tenantId}`
    const response = await axios.get(resolvePatronApiPath() + path, {
        headers: {
            Authorization: `Bearer ${await getAccessToken()}`,
            OrganizationId: tenantId
        }
    })
    return response.data
}

export type PostalInfo = {
    postalCode: string,
    postalPlace: string,
    municipalityNumber: string,
    municipalityName: string,
    countryCode: string
}

export const findNorwegianPostalInfo = async (postalCode: string): Promise<PostalInfo | undefined> => {
    try {
        return await get('/address/norwegian-postal-info', {postalCode})
    } catch (e) {
        return undefined
    }
}


const getHeaders = async (): Promise<any> => {
    const accessToken = await getAccessToken()
    if (!accessToken) {
        console.error('Attempting to call backend API without a valid access token! Should not happen!')
        return
    }

    return {
        Authorization: `Bearer ${accessToken}`
    }
}

const get = async (path: string, params: any = {}) => {
    const response = await axios.get(
        resolvePatronApiPath() + path,
        {
            headers: await getHeaders(),
            params: {
                ...Object.fromEntries(Object.entries(params).filter(([, v]) => v))
            }
        }
    )
    return response.data
}

const post = async (path: string, body: any = {}, params: any = {}) => {
    const response = await axios.post(
        resolvePatronApiPath() + path,
        body,
        {
            headers: await getHeaders(),
            params: {
                ...Object.fromEntries(Object.entries(params).filter(([, v]) => v != null))
            }
        }
    )
    return response.data
}

export const provisionPatronOrg = async (
    orgNo: string,
    orgName: string,
): Promise<any> => {
    const provisionServiceCommand = {
        organizationNumber: orgNo,
        organizationName: orgName,
        organizationType: 'AS',
        companyEmail: 'test@pracsys.no',
        phone: '12345678',
        sourceOfRegistration: 'tritt',
        address: {
            streetAddress: ['Testveien 1'],
            postalCode: '1000',
            postalPlace: 'Test Sted'
        },
        email: 'test@pracsys.no',

    }
    try {
        const response = await post('/patrons/:register', provisionServiceCommand)
        const tenantId = response?.tenantId

        if (!tenantId) {
            console.error('No tenantId returned from Patron service')
            return
        }
        await provisionTenantDirectly(orgNo, tenantId, orgName)
        return {
            organiztionId: tenantId,
            organizationName: orgName,
            organizationNumber: orgNo,
            id: tenantId
        }
    } catch (e) {
        console.error('Error creating new test org in Patron', e)
    }
}

// @ts-ignore
if(window.Cypress) {
    // @ts-ignore
    window.provisionPatronOrg = provisionPatronOrg
}